/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GuildList_guildsConnection = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly " $fragmentRefs": FragmentRefs<"GuildCardNew_guild">;
        };
        readonly cursor: string;
    }>;
    readonly " $refType": "GuildList_guildsConnection";
};
export type GuildList_guildsConnection$data = GuildList_guildsConnection;
export type GuildList_guildsConnection$key = {
    readonly " $data"?: GuildList_guildsConnection$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"GuildList_guildsConnection">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GuildList_guildsConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GuildsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Guild",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "GuildCardNew_guild"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GuildsConnection",
  "abstractKey": null
};
(node as any).hash = '49066c82392730c38d5b50f8f5a98ad7';
export default node;
